/**
 * Pricing utility functions for advertisement packages and discounts
 * Issue #220: Pre-Launch Promotion Tracking
 */

/**
 * Calculate discounted price based on discount percentage
 * @param priceCents - Original price in cents
 * @param discountPercent - Discount percentage (0-100)
 * @returns Discounted price in cents, rounded to nearest cent
 */
export const calculateDiscountedPrice = (
  priceCents: number,
  discountPercent: number
): number => {
  // Validate inputs
  if (discountPercent <= 0 || discountPercent > 100) {
    return priceCents;
  }

  if (priceCents < 0) {
    return 0;
  }

  // Calculate discount multiplier
  const discountMultiplier = (100 - discountPercent) / 100;

  // Apply discount and round to nearest cent
  return Math.round(priceCents * discountMultiplier);
};

/**
 * Format price with currency symbol
 * @param cents - Price in cents
 * @param currency - ISO 4217 currency code (e.g., 'USD', 'EUR')
 * @returns Formatted price string with currency symbol
 */
export const formatPrice = (cents: number, currency: string): string => {
  const amount = cents / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};
